export default __webpack_public_path__ + "static/media/Hardware_Track.923d3103.svg";